<template>
    <div class="text-center">
        <v-img src="@/assets/img/500.svg" :aspect-ratio="1.9274" width="636" class="mb-10"></v-img>
        <h2 class="text-primary font-weight-bold">سامانه با مشکل مواجه شده است!!!</h2>
        <p class="text-meta mb-5 mt-2 font-medium text-primary">ممکن است این موضوع لحظه‌ای باشد. لطفاً چند دقیقه دیگر مجدد این صفحه را بررسی نمایید.</p>
        <v-btn color="primary" @click="router.push({path: '/'})">بازگشت به سامانه</v-btn>
    </div>
</template>
<script setup>
defineOptions({
    auth: false,
    layout: 'error'
})
const router = useRouter();
</script>
